import axios from "axios";
const api = axios.create({
  baseURL: "https://api.kuang-bo.com",
  // baseURL: "http://localhost:8081",
  // baseURL: "http://13.215.123.31:8082",
  timeout: 10000000,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Content
 * |_ Payment
 * |  |_ getPaymentInfo
 * |  |_ getPaymentCompany
 * |  |_ getCompanys
 * |  |_ getOneCompany
 * |  |_ getSomeCompany
 * |  |_ getMonths
 */

export const getPaymentInfo = async (req) => {
  return await api
    .post("/payment/getPaymentInfo", req)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return {
          status: error.response.data.status,
          errorMessage: error.response.data.errorMessage,
        };
      } else {
        return {
          status: 500,
          errorMessage: "後端服務未啟動，請聯繫資訊人員",
        };
      }
    });
};

export const getPaymentCompany = async (req) => {
  return await api
    .post("/payment/getPaymentCompany", req)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return {
          status: error.response.data.status,
          errorMessage: error.response.data.errorMessage,
        };
      } else {
        return {
          status: 500,
          errorMessage: "後端服務未啟動，請聯繫資訊人員",
        };
      }
    });
};

export const getCompanys = async () => {
  return await api
    .post("/payment/getCompany", null)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return {
          status: error.response.data.status,
          errorMessage: error.response.data.errorMessage,
        };
      } else {
        return {
          status: 500,
          errorMessage: "後端服務未啟動，請聯繫資訊人員",
        };
      }
    });
};

export const getOneCompany = async (req) => {
  return await api
    .post("/payment/getOneCompany", req)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return {
          status: error.response.data.status,
          errorMessage: error.response.data.errorMessage,
        };
      } else {
        return {
          status: 500,
          errorMessage: "後端服務未啟動，請聯繫資訊人員",
        };
      }
    });
};
export const getSomeCompany = async (req) => {
  return await api
    .post("/payment/getSomeCompany", req)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return {
          status: error.response.data.status,
          errorMessage: error.response.data.errorMessage,
        };
      } else {
        return {
          status: 500,
          errorMessage: "後端服務未啟動，請聯繫資訊人員",
        };
      }
    });
};

export const getMonths = async (req) => {
  return await api
    .post("/payment/getMonths", req)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return {
          status: error.response.data.status,
          errorMessage: error.response.data.errorMessage,
        };
      } else {
        return {
          status: 500,
          errorMessage: "後端服務未啟動，請聯繫資訊人員",
        };
      }
    });
};

export const getReceipt = async (req) => {
  try {
    const response = await api.post("/payment/receipt", req, {
      responseType: "blob",
    });
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64data = reader.result; // data:application/pdf;base64,...
      window.location.href = base64data; // 導向可被 LINE WebView 支援的 base64 PDF
    };
    reader.readAsDataURL(response.data);
  } catch (error) {
    alert("下載失敗：" + error.message);
    // newWindow.close();
  }
};

export const testDownloadS3 = async (req) => {
  return await api
    .post("/payment/testDownloadS3", req)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return {
          status: error.response.data.status,
          errorMessage: error.response.data.errorMessage,
        };
      } else {
        return {
          status: 500,
          errorMessage: "後端服務未啟動，請聯繫資訊人員",
        };
      }
    });
};

export const Verify = async (req) => {
  return await api
    .post("/payment/verify", req)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return {
          status: error.response.data.status,
          errorMessage: error.response.data.errorMessage,
        };
      } else {
        return {
          status: 500,
          errorMessage: "後端服務未啟動，請聯繫資訊人員",
        };
      }
    });
};

export const getPaymentSummary = async (req) => {
  return await api
    .post("/payment/getPaymentSummary", req)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return {
          status: error.response.data.status,
          errorMessage: error.response.data.errorMessage,
        };
      } else {
        return {
          status: 500,
          errorMessage: "後端服務未啟動，請聯繫資訊人員",
        };
      }
    });
};

export const checkUserId = async (req) => {
  return await api
    .post("/line/checkUserId", req)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return {
          status: error.response.data.status,
          errorMessage: error.response.data.errorMessage,
        };
      } else {
        return {
          status: 500,
          errorMessage: "後端服務未啟動，請聯繫資訊人員",
        };
      }
    });
};

export const Bind = async (req) => {
  return await api
    .post("/line/bind", req)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return {
          status: error.response.data.status,
          errorMessage: error.response.data.errorMessage,
        };
      } else {
        return {
          status: 500,
          errorMessage: "後端服務未啟動，請聯繫資訊人員",
        };
      }
    });
};

export const InvoicePrint = async (req) => {
  return await api
    .post("/invoice/invoicePrint", req)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return {
          status: error.response.data.status,
          errorMessage: error.response.data.errorMessage,
        };
      } else {
        return {
          status: 500,
          errorMessage: "後端服務未啟動，請聯繫資訊人員",
        };
      }
    });
};
